// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-color[data-v-3d07bf25]{background-color:var(--bg-color)}.p-modal[data-v-3d07bf25]{padding:45px}.bg-modal[data-v-3d07bf25]{background-color:rgba(0,0,0,.5);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}@media (max-width:768px){.p-modal[data-v-3d07bf25]{padding:20px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
